// ============================================================
// コマツバラ形成外科クリニック
// 価格ゲート（方式B：価格を HTML に出力しない）
//
// snippets/price.liquid は価格の代わりに「価格を見る」という
// プレースホルダだけを出力します。このスクリプトは、
// komatsubara-cart-gate.js のパスワード認証を通過している場合にだけ
// Shopify から価格を取得して、その場所に差し込みます。
//
// 認証状態は komatsubara-cart-gate.js と共通（localStorage）です。
// 認証を求めるモーダルも同じものを再利用します。
// ============================================================

(function () {
  'use strict';

  var CONFIG = window.KPG_CONFIG || {};
  var SESSION_KEY = CONFIG.sessionKey || 'komatsubara_cart_auth';
  var MONEY_FORMAT = CONFIG.moneyFormat || '¥{{amount_no_decimals}}';
  var LABEL_REGULAR = CONFIG.labelRegular || '通常価格';
  var LABEL_SALE = CONFIG.labelSale || 'セール価格';
  var ROOT = CONFIG.root || '/';

  // 同一ページ内で同じ商品を何度も取得しないためのキャッシュ
  var productCache = new Map();

  // ----------------------------------------------------------
  // 認証状態（cart-gate と同じ localStorage キーを参照）
  // ----------------------------------------------------------
  function isAuthenticated() {
    try {
      var expiry = localStorage.getItem(SESSION_KEY + '_expiry');
      return !!expiry && Date.now() < parseInt(expiry, 10);
    } catch (e) {
      return false;
    }
  }

  function setAuthFlag() {
    document.documentElement.setAttribute('data-kpg-auth', isAuthenticated() ? 'yes' : 'no');
  }

  // ----------------------------------------------------------
  // 金額の整形（Shopify の money フィルタと同じ挙動）
  // 価格は常に「1/100 単位」で渡ってくるため 100 で割る
  // ----------------------------------------------------------
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (precision == null) precision = 2;
    if (thousands == null) thousands = ',';
    if (decimal == null) decimal = '.';
    if (isNaN(number) || number === null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var tail = parts[1] ? decimal + parts[1] : '';
    return head + tail;
  }

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var value = '';

    switch (match && match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return format.replace(placeholder, value);
  }

  // ----------------------------------------------------------
  // 商品データの取得
  // ----------------------------------------------------------
  function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    var url = ROOT.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js';
    var request = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .catch(function () {
        return null;
      });

    productCache.set(handle, request);
    return request;
  }

  function findVariant(product, variantId) {
    if (!product || !product.variants || !product.variants.length) return null;

    if (variantId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) return product.variants[i];
      }
    }
    for (var j = 0; j < product.variants.length; j++) {
      if (product.variants[j].available) return product.variants[j];
    }
    return product.variants[0];
  }

  var HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"]/g, function (c) {
      return HTML_ESCAPES[c];
    });
  }

  // ----------------------------------------------------------
  // 価格の描画（テーマ標準のクラス名に合わせています）
  // ----------------------------------------------------------
  function buildPriceHtml(variant, saleFirst) {
    var price = variant.price;
    var compareAt = variant.compare_at_price;
    var onSale = compareAt != null && compareAt > price;

    var priceText = escapeHtml(formatMoney(price, MONEY_FORMAT));
    var compareText = onSale ? escapeHtml(formatMoney(compareAt, MONEY_FORMAT)) : '';

    var regularGroup =
      '<span class="price-item__group">' +
      '<span class="visually-hidden">' +
      escapeHtml(LABEL_REGULAR) +
      '&nbsp;</span>' +
      '<span class="price-item--regular compare-at-price">' +
      compareText +
      '</span>' +
      '</span>';

    var saleGroup =
      '<span class="price-item__group">' +
      '<span class="visually-hidden">' +
      escapeHtml(LABEL_SALE) +
      '&nbsp;</span>' +
      '<span class="price-item--sale price">' +
      priceText +
      '</span>' +
      '</span>';

    return (
      '<div class="price__regular' +
      (onSale ? ' price__hidden' : '') +
      '">' +
      '<span class="price">' +
      priceText +
      '</span>' +
      '</div>' +
      '<div class="price__sale' +
      (onSale ? '' : ' price__hidden') +
      '">' +
      (saleFirst ? saleGroup + regularGroup : regularGroup + saleGroup) +
      '</div>'
    );
  }

  function fillContainer(el) {
    var handle = el.getAttribute('data-kpg-handle');
    var variantId = el.getAttribute('data-kpg-variant') || '';
    if (!handle) return;

    var stamp = handle + ':' + variantId;

    // 同じバリエーションで描画済みなら何もしない（無限ループ防止）
    if (el.dataset.kpgFilled === stamp) return;

    fetchProduct(handle).then(function (product) {
      var variant = findVariant(product, variantId);
      if (!variant) return;
      if (el.dataset.kpgFilled === stamp) return;

      el.dataset.kpgFilled = stamp;
      el.innerHTML = buildPriceHtml(variant, el.getAttribute('data-kpg-sale-first') === 'true');
    });
  }

  function revealAll() {
    if (!isAuthenticated()) return;
    var nodes = document.querySelectorAll('[data-kpg]');
    for (var i = 0; i < nodes.length; i++) fillContainer(nodes[i]);
  }

  // ----------------------------------------------------------
  // 未認証時：価格による並べ替えを隠す
  // ----------------------------------------------------------
  function hidePriceSorting() {
    if (isAuthenticated()) return;

    document.querySelectorAll('select[name="sort_by"] option').forEach(function (option) {
      if (/^price-/.test(option.value)) option.hidden = true;
    });

    document.querySelectorAll('.sorting-filter__input').forEach(function (input) {
      if (!/^price-/.test(input.value)) return;
      var label = input.closest('label');
      if (label) label.style.display = 'none';
    });
  }

  // ----------------------------------------------------------
  // 「価格を見る」操作 → 既存のパスワードモーダルを再利用
  // ----------------------------------------------------------
  function openPasswordModal() {
    var gate = window.KomatsubaraGate;
    if (!gate || typeof gate.showPasswordModal !== 'function') return;

    gate.showPasswordModal(function () {
      // 認証成功後の描画は komatsubara:authenticated イベント側で行う
    });
  }

  function onLockedActivate(event) {
    var target = event.target instanceof Element ? event.target.closest('.kpg__locked') : null;
    if (!target) return;

    // 商品カードのリンク遷移やビュートランジションより先に横取りする
    event.preventDefault();
    event.stopPropagation();
    openPasswordModal();
  }

  document.addEventListener('click', onLockedActivate, true);

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      onLockedActivate(event);
    },
    true
  );

  // ----------------------------------------------------------
  // 認証成功時
  // ----------------------------------------------------------
  document.addEventListener('komatsubara:authenticated', function () {
    setAuthFlag();
    revealAll();
  });

  // ----------------------------------------------------------
  // 初期化 ＋ 動的に差し替わる要素への追従
  // ----------------------------------------------------------
  function init() {
    setAuthFlag();
    hidePriceSorting();
    revealAll();

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        hidePriceSorting();
        revealAll();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
